import { Language } from '../types';

export const languages: Language[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    variants: [
      { code: 'en-US', name: 'English (US)' },
      { code: 'en-GB', name: 'English (UK)' }
    ]
  },
  {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    variants: [
      { code: 'es-ES', name: 'Spanish (Spain)' },
      { code: 'es-MX', name: 'Spanish (Mexico)' },
      { code: 'es-AR', name: 'Spanish (Argentina)' }
    ]
  },
  {
    code: 'fr',
    name: 'French',
    nativeName: 'Français'
  },
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch'
  },
  {
    code: 'it',
    name: 'Italian',
    nativeName: 'Italiano'
  },
  {
    code: 'pt',
    name: 'Portuguese',
    nativeName: 'Português',
    variants: [
      { code: 'pt-BR', name: 'Portuguese (Brazil)' },
      { code: 'pt-PT', name: 'Portuguese (Portugal)' }
    ]
  },
  {
    code: 'ru',
    name: 'Russian',
    nativeName: 'Русский'
  },
  {
    code: 'zh',
    name: 'Chinese',
    nativeName: '中文',
    variants: [
      { code: 'zh-CN', name: 'Chinese (Simplified)' },
      { code: 'zh-TW', name: 'Chinese (Traditional)' }
    ]
  },
  {
    code: 'ja',
    name: 'Japanese',
    nativeName: '日本語'
  },
  {
    code: 'ko',
    name: 'Korean',
    nativeName: '한국어'
  },
  {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية'
  },
  {
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी'
  },
  {
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe'
  },
  {
    code: 'nl',
    name: 'Dutch',
    nativeName: 'Nederlands'
  },
  {
    code: 'sv',
    name: 'Swedish',
    nativeName: 'Svenska'
  }
];

export const getLanguageByCode = (code: string): Language | undefined => {
  return languages.find(lang => lang.code === code || 
    lang.variants?.some(variant => variant.code === code));
};

export const getLanguageName = (code: string): string => {
  const language = getLanguageByCode(code);
  if (!language) return code;
  
  // Check if it's a variant
  if (code.includes('-')) {
    const variant = language.variants?.find(v => v.code === code);
    if (variant) return variant.name;
  }
  
  return language.name;
};